import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "reactstrap";

import { ErrorRequest } from "./body-modal/error-request";

interface IProps {
  error?: any;
  errorCode?: boolean;
  handleClose: () => void;
}
export const ModalError = (props: IProps) => {

  return (
    <Modal show={true} backdrop="static" centered className="modal-generic">
      <Modal.Body className="modal-body-generic">
        <ErrorRequest errorMessage={props.error} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.handleClose} className="cancel-error">
          {props.errorCode ? "Volver" : "Cancelar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
